
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';

import imagen from "../../../assets/logo2.jpg"

export default {

    data: () => ({
        imagen,
        columnas_reporte: [{
            text: "NOMBRE",
            align: "center",
            sortable: true,
            value: "nombre",
        },
        {
            text: "NIT",
            align: "center",
            sortable: true,
            value: "nit",
        },
        {
            text: "FECHA DEL COBRO",
            align: "center",
            sortable: true,
            value: "fecha_cobro",
        },
        {
            text: "STATUS DEL COBRO",
            align: "center",
            sortable: true,
            value: "status_cobro",
        },
        {
            text: "FECHA DECLARACIÓN",
            align: "center",
            sortable: true,
            value: "fecha_declaracion",
        },
        {
            text: "STATUS DECLARACIÓN",
            align: "center",
            sortable: true,
            value: "status_declaracion",
        }
        ],

        groupBy: ['status_cobro'],


        buscar_data: '',

        filas_reporte: [],

        menu_date: false,
        fecha_picker: '',
        fecha_txt_picker: '',

        loading: false,

        fecha_reporte: '-- , --',
        mes_reporte: '',
        anio_reporte: '',




    }),

    created() {
        console.log("esto es una prueba");



    },

    watch: {
        fecha_picker() {
            console.log(this.fecha_picker);
            let fecha = this.fecha_picker + "-01";
            this.fecha_txt_picker = fecha.split("-").reverse().join("/");
        }
    },

    methods: {
        async reporteMaestro() {
            console.log("esto es una busqueda");
            try {
                this.menu_date = false
                this.filas_reporte = [];
                this.loading = true;
                let r = await this.$store.state.services.reportesService.reporteMaestroMes(this.fecha_picker);
                console.log(r);
                this.filas_reporte 
                
                this.loading = false;
                
                r.data.data.filter(x =>{
                x.fecha_cobro = x.fecha_cobro == null ? "" : x.fecha_cobro.split("-").reverse().join("/");
                x.fecha_declaracion =  x.fecha_declaracion == null ? "" : x.fecha_declaracion.split("-").reverse().join("/");

            })    

                this.filas_reporte = r.data.data
                let mesActual = new Intl.DateTimeFormat('es-ES', { month: 'long'}).format(new Date());
                this.mes_reporte = mesActual;

                
                // crea un nuevo objeto `Date`
                let today = new Date();
                // obtener la fecha y la hora
                this.anio_reporte = today.getFullYear();
                this.fecha_reporte = today.toLocaleString();
            } catch (error) {
                console.log(error);
                this.loading = false;

                this.$toast.error("No es posible obtener datos del reporte maestro");
            }

        },

        async exportaDetallePedidoPdf() {
            var doc = new jsPDF({
              orientation: 'p',
              unit: 'mm',
              format: 'a4',
              //  putOnlyUsedFonts:true
            })
      
      
            doc.setFontSize(10)
      
            var img = new Image()
            img.src = imagen;
            doc.addImage(img, 'png', 11, 10, 40, 18)
            doc.text(80,10, `Última actualización:  ${this.fecha_reporte}`);
            
            doc.text(55, doc.internal.pageSize.height - 20, `Reporte maestro ${this.fecha_reporte} || Generado por Declara-TIC`);
      
            // for (const key in this.folios) {
            doc.text(75, 33, 'REPORTE MAESTRO DE '+ this.mes_reporte.toUpperCase() + " "+ this.anio_reporte).setFontSize(40).setFont(undefined, 'bold');
            // doc.text(19, 30, 'PRODUCTO: ' + this.folios[key].producto)
            // doc.text(19, 35, 'MEDIDA: ' + this.folios[key].medida_producto)
            let ticketData = [];
            let encabezado = ["NIT", "CLIENTE TIC","FECHA DE COBRO", "ESTATUS DE COBRO","FECHA DECLARACIÓN","ESTATUS DECLARACIÓN"];
            // let header = Object.keys(this.filas).filter(key => !encabezado.includes(key));
      
      
            // empty array of rows to fill later a bit like Excel set up.
            const tableRows = []//   w  w w    .  de   m  o   2s    .c    o m 
      
            // for each function to put tickets object in an array
            // "tickets" comes from the arg (reminder)
            this.filas_reporte.forEach(ticket => {
              ticketData = [
                ticket.nit,
                ticket.nombre,
                ticket.fecha_cobro,
                ticket.status_cobro,
                ticket.fecha_declaracion,
                ticket.status_declaracion
            ]
              tableRows.push(ticketData)
            })
      
            autoTable(doc, {
      
              head: [encabezado],
              body: tableRows, startY: 40, theme: 'grid', styles: {
                fontSize: 9,
                fontStyle: 'Arial',
                valign: 'top',
                overflow: 'linebreak',
                cellWidth: 'auto',
                cellPadding: 0.5,
                rowHeight: 0,
                halign: 'center'
              },
      
              headStyles: {
                halign: 'center',
                fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.2,
                lineColor: [0, 0, 0]
              },
            })
      
            // doc.addPage()
            // }
            doc.save(`ReporteMaestro_${this.fecha_reporte}.pdf`)
      
          },
    }
}